import styled, { css } from 'styled-components';
import { Flex, mediaMixin, PageContent, spaceMixin, token } from '@zillow/constellation';

const getBorderStyle = ({ hideBorder = false }) => {
  if (hideBorder === false) {
    return css`
      border-radius: 4px;
      border-right: solid 1px #f1f1f4;
      border-left: solid 1px #f1f1f4;
      border-bottom: solid 1px #f1f1f4;
    `;
  }
  return null;
};

export const StyledRentGuaranteeFlexContainerMultiPolicy = styled(Flex)`
  ${(props) => css`
    background-color: ${props.backgroundColor ? token(`colors.${props.backgroundColor}`) : token('colors.white')};
  `}

  ${getBorderStyle};

  cursor: pointer;
`;

export const StyledPageContent = styled(PageContent)`
  width: 100%;
  margin: 0 auto;
`;

export const StyledImageContainerMultiPolicy = styled.div`
  height: 64px;
  width: 64px;
  margin-right: ${spaceMixin('sm')};
`;

export const StyledDesktopContainerMultiPolicy = styled.div`
  ${mediaMixin(
    'sm_lte',
    css`
      display: none;
    `,
  )}
`;
